import React, { useState } from 'react';
import { openWhatsApp } from '../constants';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <button
      onClick={() => openWhatsApp()}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      title="Chat with us on WhatsApp"
      style={{
        position: 'fixed', bottom: 28, right: 28, zIndex: 999,
        background: '#25D366',
        color: '#fff',
        width: 58, height: 58,
        borderRadius: '50%',
        border: 'none',
        fontSize: 26,
        cursor: 'pointer',
        boxShadow: hovered
          ? '0 6px 24px rgba(37,211,102,0.55)'
          : '0 4px 16px rgba(37,211,102,0.38)',
        transform: hovered ? 'scale(1.12)' : 'scale(1)',
        transition: 'all 0.2s ease',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <img src="/whatsapp.png" alt="WhatsApp" style={{ height: 28 }} />
    </button>
  );
}